import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = useCallback(({ title, type, description, link }) => {
        const newNotification = {
            id: Date.now(),
            title,
            type,
            description,
            link,
        };

        setNotifications((prevNotifications) => {
            // Limiter à 3 notifications en affichant les 3 plus récentes
            if (prevNotifications.length >= 3) {
                // Retirer la première (la plus ancienne)
                return [...prevNotifications.slice(1), newNotification];
            }
            return [...prevNotifications, newNotification];
        });
    }, []);

    const removeNotification = useCallback((id) => {
        setNotifications((prevNotifications) =>
            prevNotifications.filter(notification => notification.id !== id)
        );
    }, []);

    return (
        <NotificationContext.Provider value={{ addNotification, removeNotification, notifications }}>
            {children}
        </NotificationContext.Provider>
    );
};